webpackJsonp([123315765418214],{

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic11.616f5381.jpg";

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(25);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _pic = __webpack_require__(132);
	
	var _pic2 = _interopRequireDefault(_pic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Generic = function Generic(props) {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            null,
	            _react2.default.createElement(
	                'title',
	                null,
	                'Intro'
	            ),
	            _react2.default.createElement('meta', { name: 'description', content: 'Introduction' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { id: 'main', className: 'alt' },
	            _react2.default.createElement(
	                'section',
	                { id: 'one' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'inner' },
	                    _react2.default.createElement(
	                        'header',
	                        { className: 'major' },
	                        _react2.default.createElement(
	                            'h1',
	                            null,
	                            'Introduction'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'image main' },
	                        _react2.default.createElement('img', { src: _pic2.default, alt: '' })
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'On April 24th 2013 1134 people were killed and hundreds were injured when the Rana Plaza building in Savar, Bangladesh collapsed. The unprecedented scale of the disaster meant a coordinated, systematic approach was required to ensure the victims, their families and dependents would not have to endure ill-health and financial hardship resulting from the death of a family member or life changing injuries. The Rana Plaza Arrangement was established with this objective in late 2013.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'The Rana Plaza Arrangement was a ground-breaking initiative, which, for the first time, brought together representatives from along the supply chain to agree a comprehensive and independent process that would deliver loss of income payments to those families impacted by the Rana Plaza disaster.  Between March 2014 and October 2015 the Arrangement distributed almost $30 million directly to the Rana Plaza victims, with a further $1 million paid to cover ongoing medical costs.'
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Generic;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-intro-js-49caad3ca0a431d64951.js